//#region Libraries
import styled from "styled-components";
//#endregion

export const Footer = styled.footer`
    display: flex;
    justify-content: space-between;
    &.one {
        justify-content: flex-end;
    }
    padding: 15px 30px;
    background-color: var(--light-1);
`;
export const ParagraphContentDeleteEventDialog = styled.p`
    font-size: 14px;
    color: var(--light-gray-5);
    margin-top: 5px;
`;